module.exports = __webpack_public_path__ + "static/media/04-colorOrangeImg.db1aa89b.png";